// Mirrors the etaapi backend enum (api/constants/ds/entry_screen_agent_run_status.js).
export const ENTRY_SCREEN_AGENT_RUN_STATUS = {
  RUNNING: "running",
  COMPLETED: "completed",
  COMPLETED_WITH_ERRORS: "completed_with_errors",
  FAILED: "failed",
};

export const TERMINAL_STATUSES = [
  ENTRY_SCREEN_AGENT_RUN_STATUS.COMPLETED,
  ENTRY_SCREEN_AGENT_RUN_STATUS.COMPLETED_WITH_ERRORS,
  ENTRY_SCREEN_AGENT_RUN_STATUS.FAILED,
];

// Semantic UI Label colors + human labels per run status.
export const RUN_STATUS_DISPLAY = {
  [ENTRY_SCREEN_AGENT_RUN_STATUS.RUNNING]: { color: "blue", label: "Running" },
  [ENTRY_SCREEN_AGENT_RUN_STATUS.COMPLETED]: {
    color: "green",
    label: "Completed",
  },
  [ENTRY_SCREEN_AGENT_RUN_STATUS.COMPLETED_WITH_ERRORS]: {
    color: "yellow",
    label: "Completed with errors",
  },
  [ENTRY_SCREEN_AGENT_RUN_STATUS.FAILED]: { color: "red", label: "Failed" },
};

export const isTerminalStatus = (status) => TERMINAL_STATUSES.includes(status);

export const TIMESTAMP_FORMAT = "DD-MMM-YYYY HH:mm:ss";

// Auto-poll the active run every 5s, capped at ~5 minutes so a stuck run never polls forever.
export const POLL_INTERVAL_MS = 5000;
export const MAX_POLLS = 60;
